import { useState } from "react"

export const useDiscountFormHandling = () => {
    const [formData,setFormData] = useState({
        gInsurer: "",
        name: "",
        code: "",
        gProduct: "",
        gPolicyType: "",
        isActive: true,

        gInsurerStatus: "unchecked",
        nameStatus: "unchecked",
        codeStatus: "unchecked",
        gProductStatus: "unchecked",
        gPolicyTypeStatus: "unchecked"

    });    

    const handleChange = (event,selectEvent) => {
        let formState ={...formData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "gInsurer": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "gProduct": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "gPolicyType": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.gInsurerStatus === "success" &&
        formData.gDiscountStatus === "success" &&
        formData.nameStatus === "success" &&
        formData.codeStatus === "success" &&
        formData.gProductStatus === "success" &&
        formData.gPolicyTypeStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}